/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/mark-out-icon/mark-out-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=mark-out-icon.component.css.map */
